import { useNonF2fMedicalCategoriesQuery } from './medicalCategory.gql.impl';

const useNonF2fMedicalCategories = (size = 9) => {
  const { data, isLoading, error } = useNonF2fMedicalCategoriesQuery({ size });

  const medicalCategories = data?.nonF2fMedicalCategories ?? [];

  return {
    medicalCategories,
    isLoading,
    error,
  };
};

export default useNonF2fMedicalCategories;
